// clientSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import type { ThunkExtra } from "../store";

type ClientState = {
  client: any;
};

const initialState: ClientState = {
  client: "",
};

export const fetchClientUid = createAsyncThunk<
  string,
  void,
  { extra: ThunkExtra }
>("/fetchClientUid", async (_, { extra }) => {
  const res = await axios.get(`${extra.baseUrl}/getClientUid`);
  return res.data.client;
});

const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    setClientUid: (state, action) => {
      state.client = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClientUid.fulfilled, (state, action) => {
      state.client = action.payload;
    });
  },
});

export const { setClientUid } = clientSlice.actions;
export default clientSlice.reducer;
